$(document).ready(function(){

})



// WEBPACK FOOTER //
// ./scripts/blocks.js